<template>
  <div v-if="enrollment_status.enrollment || isExtempEnrollment || isExtempGenEnrollment">
    <v-toolbar
      style="background-color: rgb(0,153,204)"
      dark
      flat
    >
        <v-toolbar-title v-if="enrollment_status.enrollment">
          {{ enrollment_status.enrollment.description }} 
          <v-chip color="orange" class="font-weight-black" v-if="system_access && (isExtempEnrollment || isExtempGenEnrollment)">Extemporánea</v-chip>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div>
          <span v-if="enrollment_status.enrollment || isExtempGenEnrollment"><b>{{ step > 1 ? student.first_name : $t(`enrollments.select_student`) }}</b></span>
          <span v-if="enrollment_status.enrollment && step > 1">- {{ $t(`enrollments.grade`) }} {{ student.next_grade }}</span>
        </div>
    </v-toolbar>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'enrollment-info-view',
    props: {
      step: {
          type: [String, Number],
          required: false,
      },
      system_access: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      ...mapGetters({
        enrollment_id: 'currentEnrollmentId',
        enrollment_status: 'currentEnrollment',
        sons: 'currentEnrollmentSons',
        student: 'currentEnrollmentStudent',
        isExtempEnrollment: 'isExtempEnrollment',
        isExtempGenEnrollment: 'isExtempGenEnrollment',
      }),
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_info.vue